export const ALL_CITY_REQUEST = "ALL_CITY_REQUEST"
export const ALL_CITY_SUCCESS = "ALL_CITY_SUCCESS"
export const ALL_CITY_FAIL = "ALL_CITY_FAIL"